import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "table-responsive" }
const _hoisted_2 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_3 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
}
const _hoisted_6 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_7 = {
  key: 0,
  class: "shadow-none lh-1 fw-medium text-body-tertiary text-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t('form.date.label')), 1 /* TEXT */),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (step) => {
            return (_openBlock(), _createElementBlock("th", {
              scope: "col",
              class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end",
              key: step.id
            }, [
              _createElementVNode("span", {
                innerHTML: step.title
              }, null, 8 /* PROPS */, _hoisted_4)
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          (_ctx.env === 'kareena')
            ? (_openBlock(), _createElementBlock("th", _hoisted_5, _toDisplayString(_ctx.$t('feature.surveys.role')), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.responses, (response) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: response.id
          }, [
            _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.YYYYMMDD(response.date)), 1 /* TEXT */),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (step) => {
              return (_openBlock(), _createElementBlock("td", {
                class: "shadow-none lh-1 fw-medium text-body-tertiary text-end",
                key: `asnwer-${step.id}`
              }, _toDisplayString(_ctx.$s.getAnswer(step.id!, response)), 1 /* TEXT */))
            }), 128 /* KEYED_FRAGMENT */)),
            (_ctx.env === 'kareena')
              ? (_openBlock(), _createElementBlock("td", _hoisted_7, _toDisplayString(_ctx.$t(`feature.roles.$type.${response.created_by_role ?? _ctx.role.patient}`)), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
}